import React, { useEffect, useRef, useState } from "react";
import ImageCarousel from "../../components/client/ImageCarousel";
import NewsLayout from "../../components/client/NewLayout";
// import Event from "../../components/client/Event";
import Posts from "../../components/client/Posts";
import Category from "../../components/client/Category";
import YouTubePosts from "../../components/client/YoutubePosts";
import MemberRegistrationForm from "../../components/client/MemberRegistrationForm";
import PostsReadMore from "../../components/client/PostsReadMore";
import Activiti from "../../components/client/Activiti";
import SocialResponsibility from "../../components/client/SocialResponsibility";
import BusinessVisit from "../../components/client/BusinessVisit";
import NewsList from "../../components/client/NewListOther";
import NewsList2 from "../../components/client/NewListOther2";
import LogoSlider from "../../components/client/LogoSlider";
import SponsorLogoSlider from "../../components/client/SponsorLogoSlider";
import Member from "../../components/client/Members";
import ButtonTitle from "../../components/ButtonTitle";
import ApiCustom from "../../utils/ApiCustom";

function Home() {
  const [adsData, setAdsData] = useState();

  useEffect(() => {
    getAds();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const getAds = () => {
    ApiCustom.get("product-show-with-priority")
      .then((res) => {
        setAdsData(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const handleScroll = () => {
      if (memberFormRef.current) {
        const offset = 130;
        const elementPosition =
          memberFormRef.current.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
      }
    };

    window.addEventListener("scrollToMemberForm", handleScroll);

    return () => {
      window.removeEventListener("scrollToMemberForm", handleScroll);
    };
  }, []);

  const memberFormRef = useRef(null);

  return (
    <div>
      <ImageCarousel />
      <NewsLayout data={adsData} />
      {/* <Event /> */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 mb-2">
        <div className=" rounded-lg shadow">
          <Posts />
        </div>
        <div className="p-2 rounded-lg shadow">
          <Category /> <br />
          <ButtonTitle title="Bài đọc nhiều" />
          <PostsReadMore />
        </div>

        <div className="p-2 rounded-lg shadow">
          <YouTubePosts />
          <br />
          <div ref={memberFormRef}>
            <ButtonTitle title="Đăng Ký Hội Viên" />
          </div>
          <MemberRegistrationForm useId={true} />
        </div>
      </div>
      <ButtonTitle title="Hoạt động" />
      <Activiti />
      <ButtonTitle title="Trách nhiệm xã hội" />
      <SocialResponsibility />
      <ButtonTitle title="Thăm doanh nghiệp" />
      <BusinessVisit />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 mb-3">
        <div className="p-2  rounded-lg shadow">
          <ButtonTitle title="Tin tức - Sự kiện" />
          <NewsList />
        </div>
        <div className="p-2  rounded-lg shadow">
          <ButtonTitle title="Kinh tế - Tài chính" />
          <NewsList2 />
        </div>

        <div className="p-2  rounded-lg shadow">
          <ButtonTitle title="Hội viên BCCU mới" />
          <LogoSlider />
        </div>
      </div>
      <ButtonTitle title="Nhà tài trợ" />
      <SponsorLogoSlider />
      <ButtonTitle title="Hội viên BCCU" />
      <Member />
    </div>
  );
}

export default Home;
